import TermSlider from "../TermSlider";
import RefinanceAmount from "../RefinanceAmount";
import CreditRatingSelect from "../CreditRatingSelect";

export default function RefinanceForm() {
  return (
    <React.Fragment>
      <TermSlider />
      <RefinanceAmount />
      <CreditRatingSelect />
    </React.Fragment>
  );
}


// WEBPACK FOOTER //
// blocks/quote-calculator/app/components/LoanOptions/components/forms/RefinanceForm.js